import { TrackingType } from '@innedit/innedit-type';

import Model, { ModelProps } from '../../Model';

class Tracking extends Model<TrackingType> {
  constructor(props: Omit<ModelProps<TrackingType>, 'collectionName'>) {
    super({
      canDoSearch: false,
      collectionName: 'trackings',
      labelFields: ['start'],
      orderDirection: 'desc',
      orderField: 'createdAt',
      queryBy: '',
      ...props,
    });
  }

  public initialize(data?: Partial<TrackingType>): Partial<TrackingType> {
    return super.initialize({
      nbChildren: 0,
      ...data,
    });
  }
}

export default Tracking;
